/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Injectable} from '@angular/core';
export class RowActionService {
private actionableCount = 0;
/**
 * @return {?}
 */
public register() {
        this.actionableCount++;
    }
/**
 * @return {?}
 */
public unregister() {
        this.actionableCount--;
    }
/**
 * false means no rows with action
 * @return {?}
 */
public get hasActionableRow(): boolean {
        return this.actionableCount > 0;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function RowActionService_tsickle_Closure_declarations() {
/** @type {?} */
RowActionService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RowActionService.ctorParameters;
/** @type {?} */
RowActionService.prototype.actionableCount;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
